import { render, staticRenderFns } from "./aws.vue?vue&type=template&id=e5fa5648&scoped=true"
import script from "./aws.vue?vue&type=script&lang=js"
export * from "./aws.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fa5648",
  null
  
)

export default component.exports